import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';

const AppHeader = () => {
  return (
    <div className="bg-white border-b border-neutral-200 shadow-soft">
      <div className="w-full max-w-[1600px] mx-auto px-6 lg:px-10 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-medium">
              <FiMessageCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-neutral-900">WhatsApp Service</h1>
              <p className="text-sm text-neutral-500">Cloud API messaging &amp; conversations</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
